import Button from '@mui/material/Button';
import { ReactElement, ReactNode } from 'react';

import ceStyles from '~/ui/pages/Clients/reusable/CommunityEngagement/CommunityEngagement.module.scss';

import styles from './ArchivedRow.module.scss';

interface IArchivedRowProps {
  title: ReactNode;
  subtitle: string;
  onRestore: () => void;
  isRestoreDisabled?: boolean;
}

const ArchivedRow = ({
  title,
  subtitle,
  onRestore,
  isRestoreDisabled = false,
}: IArchivedRowProps): ReactElement => (
  <div className={styles.archivedRow}>
    <div>
      <div className={styles.archivedTitle}>{title}</div>
      <div className={ceStyles.rowSubtitle}>{subtitle}</div>
    </div>
    <Button color="primary" size="small" disabled={isRestoreDisabled} onClick={onRestore}>
      Restore
    </Button>
  </div>
);

export default ArchivedRow;
